<template>
    <ChannelsGeneral title="MMS" subtitle="Cut through the noise with rich content" grey="true">
        <template #content>
            <p>
                Share more than words with <b>encrypted and link-trackable PDFs</b>, high-quality images, or short videos delivered straight to any Australian mobile number. 
                <br><br>With <b>90% open rates</b> and seamless integration with SMS, MMS is the cost-effective way to <b>replace direct mail</b> and create conversations that cut through the noise.
                <br>
            </p>
        </template>
        <template #img>
            <v-img
            src="../assets/img/mms.png"
            max-width="500px"
            alt="MMS example"
            contain />
        </template>
    </ChannelsGeneral>
</template>

<script>
import ChannelsGeneral from './ChannelsGeneral.vue'

export default {
    name: 'ChannelsMMS',
    components: {
    ChannelsGeneral
    }
}
</script>

<style lang="scss">
</style>